import React, { useContext, useEffect, useState } from 'react'
import TopSearch from '../../components/TopSearch'
import Context from '../../context'
import { getSearch } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

export default function CourtesiesList() {
  const { editPartner, setEditCourtesy, setUser } = useContext(Context)
  const [courtesyList, setCourtesyList] = useState([])
  const [fullCourtesyList, setFullCourtesyList] = useState([])
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [isLoading, setIsLoading] = useState(false)

  const getUnityName = async unityId => {
    // const unityData = await getUnityById(unityId, editPartner.id);
    // return unityData.companyData.fantasyName;
  }

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
  }, [])

  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)
      getSearch('courtesy', searchData.str).then(r => {
        // setChallengeList(r);
        setSearchData({ ...searchData, startSearch: false })
        setIsLoading(false)
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setCourtesyList(fullCourtesyList)
    }
  }, [searchData])

  useEffect(() => {
    const getList = async () => {
      const list = []
      let newArr = []

      if (list.length > 0) {
        newArr = Promise.all(
          list.map(async item => {
            const unityName = await getUnityName(item.unityId, editPartner.id)
            return { ...item, unityName }
          })
        )
      }
      return newArr
    }

    if (editPartner.id !== null) {
      getList().then(list => {
        setCourtesyList(list)
        setFullCourtesyList(list)
      })
    } else {
      history.replace('/')
    }
  }, [editPartner])

  const handleCourtesyClick = async courtesyId => {
    const courtesyToEdit = courtesyList.filter(listItem => {
      return courtesyId === listItem.id
    })
    if (courtesyToEdit.length > 0) {
      setEditCourtesy(courtesyToEdit[0])
      history.push('/courtesyform')
    }
  }

  return (
    <div className="container-fluid">
      <Context.Provider value={{ searchData, setSearchData }}>
        <TopSearch />
      </Context.Provider>
      <table className="table">
        <thead className="thead-dark">
          <tr>
            <th>Cortesia</th>
            <th>Unidade Atrelada</th>
          </tr>
        </thead>
        <tbody>
          {courtesyList.length > 0 &&
            courtesyList.map(courtesy => (
              <tr
                key={courtesy.id}
                onClick={() => handleCourtesyClick(courtesy.id)}
                className="item-click"
                itemScope="row"
                id={`partner-${courtesy.id}`}
              >
                <td>{courtesy.name}</td>
                <td>{courtesy.unityName}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}
